import { PmsType } from "@/types/hotel";

/**
 * Maps each known PMS provider to its i18n label key (resolved via `t()` by the
 * consumer). Keyed by `PmsType` so adding a provider to the enum forces a label
 * entry here at compile time. Providers returned by the API that are not in the
 * enum fall back to their raw `type` string at the call site.
 */
export const PMS_PROVIDER_LABEL_KEYS: Record<PmsType, string> = {
  [PmsType.MEWS]: "pms.providerLabels.MEWS",
  [PmsType.OPERA]: "pms.providerLabels.OPERA",
};

/**
 * Narrows an API-provided provider string to `PmsType`, returning `undefined`
 * for unknown values so callers can fall back explicitly.
 */
const toPmsType = (value?: string): PmsType | undefined =>
  value && Object.values(PmsType).includes(value as PmsType)
    ? (value as PmsType)
    : undefined;

/**
 * The single source-of-truth chain for the hotel's active PMS provider: saved
 * PMS settings win over the credentials status, which wins over the hotel's
 * default. Used by both the connector card and the credentials form so the two
 * can never disagree.
 */
export const resolveActivePmsProvider = (
  settingsProvider?: string,
  credentialsProvider?: string,
  hotelProvider?: PmsType,
): PmsType | undefined =>
  toPmsType(settingsProvider) ??
  toPmsType(credentialsProvider) ??
  hotelProvider;
